import React, { Component } from 'react';
import renderHTML from 'react-render-html';
import classes from './Intro.module.scss';


import MediaQuery from 'react-responsive';
import { DFPSlotsProvider, AdSlot } from 'react-dfp';
import { Online } from 'react-detect-offline';
import IsNotDomestic from 'helpers/IsNotDomestic'

import globalJSON from 'data/global.json';

class Intro extends Component {

    constructor(props){

        super(props);

    }

    render(){
        return (
            <div className={classes['intro']}> 

                <p className={classes['intro__paragraph']}>      
                    <span className={`initial`}>{this.props.content.dropCap}</span>
                    {renderHTML(this.props.content.text)}
                </p>
                <IsNotDomestic>
                    <Online>
                        <MediaQuery maxWidth={classes.screenMaxXl}>
                            <div className={`MPU`}>
                            <p className={`MPU__readmore`}>Article continues below</p>
                            <DFPSlotsProvider targetingArguments={{ column: globalJSON.advertising.column }} dfpNetworkId={`${globalJSON.advertising.networkID}`} adUnit={`${globalJSON.advertising.adUnit}`}>
                                <div className={`MPU__Wrapper`}>
                                    <div className={`MPU__mpu`}>
                                        <p className={`ads_title MPU__Title`}>advertisement</p>
                                        <div className={`MPU__Ads`}>
                                            <AdSlot sizes={[ [300, 250] ]} />
                                        </div>
                                    </div>
                                </div>
                            </DFPSlotsProvider>
                            </div>
                        </MediaQuery>
                    </Online>
                </IsNotDomestic>
            </div>

          
        );
    }
}

export default Intro;